import React from 'react';
import UserProfileTemplate from 'mrf/view/UserProfileTemplate';

export default function UserProfile() {
    return <UserProfileTemplate />;
}
